import React from "react";
import "../../styles/ServicePages.css";

const AirCargoPage = () => {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <div className="service-hero">
        <h1>✈️ Air Cargo Services</h1>
        <p>Fast, reliable domestic and international freight solutions for time-sensitive shipments and global delivery</p>
      </div>

      {/* Main Content */}
      <div className="service-content">
        {/* Overview */}
        <section className="overview-section">
          <h2>Express Delivery at Your Speed</h2>
          <p className="overview-text">
            AROCL provides comprehensive air cargo services connecting you to domestic and international markets. 
            Specialized cold chain logistics for pharmaceuticals, electronics, and perishables ensures your goods arrive in perfect condition.
          </p>
        </section>

        {/* Features Grid */}
        <section className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">⚡</span>
            <h3>Express Delivery</h3>
            <p>Fast domestic and international freight with priority handling and express tracking</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🧊</span>
            <h3>Cold Chain Logistics</h3>
            <p>Temperature-controlled transport for pharmaceuticals, biologics, and perishable goods</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🎯</span>
            <h3>Time-Sensitive Solutions</h3>
            <p>Specialized handling for urgent and time-critical shipments with guaranteed delivery</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🌐</span>
            <h3>Global Reach</h3>
            <p>Access to major international airports and global airline partnerships</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📡</span>
            <h3>Real-Time Tracking</h3>
            <p>Complete visibility from pickup to delivery with live tracking updates</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔒</span>
            <h3>Security & Compliance</h3>
            <p>Full customs clearance support and regulatory compliance for all shipments</p>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <h2>Why Air Cargo with AROCL?</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Speed & Reliability</h4>
                <p>Guaranteed delivery windows with minimal delays and 99.8% on-time performance</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Specialized Handling</h4>
                <p>Expert care for high-value, fragile, or hazardous materials</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Customs Integration</h4>
                <p>Seamless international documentation and cleared through customs</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Cost Optimization</h4>
                <p>Competitive rates with volume discounts and flexible pricing models</p>
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="process-section">
          <h2>Air Cargo Journey</h2>
          <div className="process-timeline">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Booking & Pickup</h3>
              <p>Schedule shipment and arrange convenient pickup with our logistics team</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Consolidation</h3>
              <p>Goods consolidated and prepared for air transport with proper documentation</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Air Transport</h3>
              <p>Fast flight with real-time tracking and continuous monitoring</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Delivery</h3>
              <p>Final delivery to destination with customs clearance and documentation</p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="stat-card">
            <div className="stat-number">80+</div>
            <div className="stat-label">Global Destinations</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">99.8%</div>
            <div className="stat-label">On-Time Delivery</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">24hrs</div>
            <div className="stat-label">Average Transit</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">10K+</div>
            <div className="stat-label">Shipments Yearly</div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <h2>Need Fast Delivery?</h2>
          <p>Get your urgent shipments to their destination quickly with AROCL's air cargo solutions.</p>
          <div className="cta-buttons">
            <button className="cta-btn cta-btn-primary" onClick={() => window.location.href = "tel:+919876543210"}>📞 Call Now</button>
            <button className="cta-btn cta-btn-secondary" onClick={() => window.location.href = "https://wa.me/919876543210?text=I need air cargo services for my shipment."}>💬 Chat on WhatsApp</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AirCargoPage;
